import React from 'react';
import { useSelector } from 'react-redux';
import { selectMyPlayer } from '../../redux/gameSlice';
import { Trans } from '@lingui/macro';

export default function EnergyContainer(props) {
    const myPlayer = useSelector(selectMyPlayer);

    return <div id="energy-container">
        <div id="energy-icon" className="game-sprite"></div>
        <div id="player-energy-container">
            <p id="player-energy">{myPlayer.energy}</p>
            <p className="content-title"><Trans>My energy</Trans></p>
        </div>
    </div>;
}
